import { cn } from "@/lib/utils";

export type StatusTone = "green" | "red" | "amber" | "blue" | "purple" | "gray";

const TONE_CLASSES: Record<StatusTone, string> = {
  green: "bg-fabrik-green-soft text-fabrik-green",
  red: "bg-fabrik-red-soft text-fabrik-red",
  amber: "bg-fabrik-orange-soft text-fabrik-orange",
  blue: "bg-fabrik-blue-soft text-fabrik-blue",
  purple: "bg-fabrik-purple-soft text-fabrik-purple",
  gray: "bg-muted text-muted-foreground",
};

export interface StatusPillProps {
  label: string;
  tone?: StatusTone;
  className?: string;
}

export function StatusPill({
  label,
  tone = "gray",
  className,
}: StatusPillProps) {
  return (
    <span
      data-slot="status-pill"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
        TONE_CLASSES[tone],
        className,
      )}
    >
      <span className="size-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
